import React, { useState, useEffect, useCallback } from 'react'
import Tooltip from 'rc-tooltip'
import Modal from 'react-responsive-modal'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

const Hint = ({
  text,
  style,
  isOtherActivated,
  isLargeScreen,
  outerTrigger = null,
  entity,
  placement,
  onHover,
  className
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const onVisibleChange = useCallback(() => {
    if (!isLargeScreen) {
      setIsModalOpen(!isModalOpen)
    }
  }, [isLargeScreen, isModalOpen])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleMouseEnter = useCallback(() => {
    if (outerTrigger !== null && isLargeScreen) {
      onHover && onHover(entity)
      setIsHovered(true)
    }
  }, [onHover, entity, outerTrigger, isLargeScreen])

  const handleMouseLeave = useCallback(() => {
    if (outerTrigger !== null && isLargeScreen) {
      onHover && onHover(null)
      setIsHovered(false)
    }
  }, [onHover, outerTrigger, isLargeScreen])

  const overlayStyle = isLargeScreen ? {} : { display: 'none' }

  let extraProps = outerTrigger !== null && isLargeScreen ? { visible: outerTrigger || isHovered } : {}

  if (isOtherActivated && isOtherActivated !== entity && Object.keys(extraProps).length > 0) {
    extraProps.visible = false
  }

  let finalClassName = 'shint'

  if (className) {
    finalClassName += ` ${className}`
  }

  // force the hint icon to be green when activated from outside trigger: simulate hover
  const extraStyle = extraProps.visible && !isHovered ? { backgroundPosition: '-20px 0' } : {}

  const hintContent = (
    <div className='hint-body hint-body-style'>{typeof text === 'object' ? text : ReactHtmlParser(text)}</div>
  )

  const responsiveHintContent = isLargeScreen ? (
    hintContent
  ) : (
    <Modal center open={isModalOpen} onClose={handleCloseModal} showCloseIcon={false}>
      {hintContent}
      <button className='close-hint-button' onClick={handleCloseModal}>
        {I18n.t('modals.close')}
      </button>
    </Modal>
  )

  return (
    <Tooltip
      {...extraProps}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      placement={I18n.locale === 'ar' ? 'left' : placement}
      onClick={onVisibleChange}
      overlay={isLargeScreen ? hintContent : <div />}
      overlayStyle={overlayStyle}
    >
      <span className={finalClassName} style={{ ...style, ...extraStyle }}>
        {!isLargeScreen && responsiveHintContent}
      </span>
    </Tooltip>
  )
}

Hint.propTypes = {
  text: PropTypes.node,
  style: PropTypes.object,
  isOtherActivated: PropTypes.string,
  isLargeScreen: PropTypes.bool,
  outerTrigger: PropTypes.bool,
  entity: PropTypes.string,
  placement: PropTypes.string,
  onHover: PropTypes.func,
  className: PropTypes.string
}

export default Hint
